export default {
  label: {
    time: 'Search by time',
    orderNo: 'Search by transaction code',
    systemOrderNo: 'transaction code',
    context: 'context',
    createTime: 'Creation time',
    id: 'Primary key ID',
    message: 'Description',
    params: 'Request parameter',
    request: 'Request path or url',
    response: 'Response result',
    step: 'step',
    timeline: 'timeline',
    callback: 'Callback',
    callbackParams: 'Parameter'
  }
};



// WEBPACK FOOTER //
// ./src/i18n/lang/en/transactionRecord.js